import React, { Component } from "react";
import { connect } from "react-redux";

import moment from "moment";

import {
  fetchPendingInventoryDetail,
  fetchPendingInventoryDetailSuccess,
  fetchPendingInventoryDetailFailure,
} from "../../store/pendingInventory/actions";

import { addPendingToInventory } from "../../store/pendingInventory/api";

import Alert from "../../utils/Alert";
import Modal from "../../components/generics/Modal";
import Spinner from "../../components/generics/Spinner";
import DetailHeader from "../../components/generics/DetailHeader";

import PendingInventoryForm from "../../components/pendingInventory/PendingInventoryForm";
import { withRouter } from "utils/WithRouter";

export class PendingInventoryDetailContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inventoryData: {
        weight: "",
        number_items: 1,
        plant: "",
        vendor_lot_number: "",
        temperature: "",
        box_condition: "good",
        packing_date: "",
        openWeightGreaterEqualThanHundredModal: false,
      },
      errors: [],
    };

    this.alertRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchPendingInventory(this.props.match.params.id, this.props, this.alertRef);
  }

  componentDidUpdate(prevProps) {
    const { detail, loading } = this.props.pendingInventory;
    const prevPending = prevProps.pendingInventory;
    if (!loading && detail && detail.id && (!prevPending.detail || !prevPending.detail.id || prevPending.detail.id !== detail.id)) {
      let inventoryData = this.state.inventoryData;
      inventoryData.number_items = detail.number_items;
      inventoryData.plant = detail.plant;
      inventoryData.weight = detail.weight !== 0 ? detail.weight : "";
      inventoryData.temperature = detail.temperatures && detail.temperatures[0] ? detail.temperatures[0].value : "";
      inventoryData.vendor_lot_number = detail.vendor_lot_number;
      inventoryData.packing_date = detail.packing_date ? moment(detail.packing_date).format("YYYY-MM-DD") : undefined;
      this.setState({ inventoryData });
    }
  }

  handleValueChange = (inputType, value) => {
    this.setState((prevState) => {
      const newErrors = prevState.errors;
      const inputErrorIndex = prevState.errors.indexOf(inputType);
      if (inputErrorIndex !== -1) {
        newErrors.splice(inputErrorIndex, 1);
      }
      return {
        ...prevState,
        inventoryData: {
          ...prevState.inventoryData,
          [inputType]: value,
        },
        errors: newErrors,
      };
    });
  };

  handleAddToInventory = (skipWeightCheck) => {
    const { inventoryData } = this.state;
    const { detail } = this.props.pendingInventory;
    const newErrors = [];
    if (isNaN(parseFloat(inventoryData.weight)) || inventoryData.weight <= 0) {
      newErrors.push("weight");
    }
    if (isNaN(parseInt(inventoryData.number_items, 10)) || inventoryData.number_items <= 0) {
      newErrors.push("number_items");
    }
    if (inventoryData.temperature !== "" && isNaN(parseFloat(inventoryData.temperature))) {
      newErrors.push("temperature");
    }
    if (!inventoryData.plant) {
      newErrors.push("plant");
    }
    if (!inventoryData.vendor_lot_number) {
      newErrors.push("vendor_lot_number");
    }
    if (!inventoryData.packing_date || inventoryData.packing_date > moment()) {
      newErrors.push("packing_date");
    }
    this.setState({
      errors: newErrors,
    });
    if (newErrors.length === 0) {
      if (inventoryData.weight >= 100 && !skipWeightCheck) {
        this.setState({ openWeightGreaterEqualThanHundredModal: true });
      } else {
        const data = {
          weight: parseFloat(inventoryData.weight),
          number_items: parseInt(inventoryData.number_items, 10),
          plant: inventoryData.plant,
          temperature: inventoryData.temperature !== "" ? parseFloat(inventoryData.temperature) : undefined,
          box_condition: inventoryData.box_condition,
          packing_date: inventoryData.packing_date,
          vendor_lot_number: inventoryData.vendor_lot_number,
        };
        addPendingToInventory(detail.id, data).then(
          () => {
            this.alertRef.current.sendAlert(`Inventory #${detail.id} has been successfully activated`, "success");
            this.props.history.push("/pending_inventory");
          },
          (error) => {
            this.alertRef.current.sendAlert("Something went wrong");
            if (error && error.response) {
              this.setState({
                errors: Object.keys(error.response.data),
              });
            }
          }
        );
      }
    }
  };

  render() {
    const { detail, loading } = this.props.pendingInventory;
    if (loading || !detail)
      return (
        <div>
          <Alert ref={this.alertRef} />
          <Spinner />
        </div>
      );

    const { inventoryData, errors } = this.state;
    return (
      <div>
        <Alert ref={this.alertRef} />
        <Modal
          closeModal={() => this.setState({ openWeightGreaterEqualThanHundredModal: false })}
          isModalOpen={this.state.openWeightGreaterEqualThanHundredModal}
          onConfirm={() => {
            this.handleAddToInventory(true);
          }}
          onCancel={() => this.setState({ openWeightGreaterEqualThanHundredModal: false })}
          header="Weight greater than or equal to 100"
          content="Weight is greater than or equal to 100, are you sure you want to proceed?"
          onConfirmButtonText="Yes"
          onCancelButtonText="No"
        />
        <DetailHeader
          onlyHeader
          action2Available
          title={`#${detail.id} - ${detail.item.name}`}
          actionTitle="Add to Inventory"
          actionClass="btn btn-primary m-0 hidden-xs-down"
          actionIconClass="fa fa-check mr-05"
          action={() => this.handleAddToInventory(false)}
          action2Title=""
          action2Class="btn btn-primary m-0 hidden-sm-up"
          action2IconClass="fa fa-check"
          action2={() => this.handleAddToInventory(false)}
        />
        <PendingInventoryForm
          item={detail.item}
          inventory={inventoryData}
          errors={errors}
          onValueChange={this.handleValueChange}
          onSubmit={() => this.handleAddToInventory(false)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    pendingInventory: state.pendingInventory.pendingInventoryDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPendingInventory: (id, props, alertRef) => {
      dispatch(fetchPendingInventoryDetail(id)).payload.then(
        (response) => {
          dispatch(fetchPendingInventoryDetailSuccess(response.data));
        },
        (error) => {
          if (error && error.response && error.response.status === 404) {
            alertRef.current.sendAlert(`Inventory #${id} has already been processed`);
            props.history.push("/pending_inventory");
          }
          dispatch(fetchPendingInventoryDetailFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PendingInventoryDetailContainer));
